import { Skeleton, Stack, Typography } from '@mui/material';

export interface FilterFieldSkeletonProps {
  height?: number | string;
  hideLabel?: boolean;
  labelWidth?: number | string;
}

export function FilterFieldSkeleton({
  height = 40,
  hideLabel,
  labelWidth = '45%',
}: FilterFieldSkeletonProps) {
  return (
    <Stack gap={0.5} width="100%">
      {!hideLabel && (
        <Typography variant="subtitle2" width={labelWidth}>
          <Skeleton />
        </Typography>
      )}
      <Skeleton variant="rounded" height={height} />
    </Stack>
  );
}
